import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import {InputMask} from "primereact/inputmask";
import {Calendar} from "primereact/calendar";
import moment from 'moment';
import axios from "axios";
import {AutoComplete} from "primereact/autocomplete";

const CooperationFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [status, setStatus] = useState([]);

  const [partners, setPartners] = useState([]);
  const [partnerQuery, setPartnerQuery] = useState(
    window.App.urlVars().partnerName ? decodeURIComponent(window.App.urlVars().partnerName) : ''
  );
  const [partnerLoading, setPartnerLoading] = useState(false);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().cooperationId) || (entity === 'cooperation' && id)) {
      apiCall('patch', '/api/v2/production-item/subcontractor-list/' + (window.App.urlVars().cooperationId ?? id), newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderCooperationList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/production-item/subcontractor-list', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderCooperationList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/production/cooperation/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const searchPartner = (event) => {
    const q = (event?.query || '').trim();
    setPartnerQuery(q);
    if (q.length < 2) {
      setPartners([]);
      return;
    }
    setPartnerLoading(true);
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/partner", {
      params: {
        item_per_page: 15,
        'search[name][operator]': 'like',
        'search[name][value]': `%${q}%`,
        'search[customer][operator]': '==',
        'search[customer][value]': 'true'
      },
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        const items = response?.data?.data?.items || [];
        const mapped = items.map(item => ({
          ...item,
          displayName: item.name || `#${item.id}`
        }));
        setPartners(mapped);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setPartnerLoading(false);
      });
  };

  useEffect(() => {
    const urlVars = window.App.urlVars();
    if (urlVars.partnerId) {
      const partnerId = Number(urlVars.partnerId);
      const partnerName = urlVars.partnerName ? decodeURIComponent(urlVars.partnerName) : '';
      setPartnerQuery(partnerName);
      setFormData(prev => ({
        ...prev,
        subcontractor: partnerId
      }));
      setNewFormData(prev => ({
        ...prev,
        subcontractor: partnerId
      }));
    }
  }, [window.location.hash]);

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().cooperationId) || (entity === 'cooperation' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/production-item/subcontractor-list/' + (window.App.urlVars().cooperationId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/dictionary/production-status', {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
    .then(response => {
      setStatus(response.data.data)
    })
  }, [])

  return (
    <div className={"cooperation-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6"} id="partner">
                          <Field name="subcontractor" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                              <label htmlFor="subcontractor" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPartner')}</label>
                              <span className={"p-field p-inputgroup"}>
                                  <Button type="button" className={"p-button"}
                                          onClick={() => {
                                            const currentPath = window.location.hash.replace('#', '').split('?')[0];
                                            let _params = '?';
                                            Object.entries(window.App.urlVars()).forEach(([key, value]) => {
                                              _params += key + '=' + value + '&';
                                            });
                                            _params += 'backlink=' + encodeURIComponent(currentPath) + '&';
                                            _params += 'search=partner';
                                            history.push(currentPath + _params);
                                          }}>
                                    <i className={"pi pi-search"}></i>
                                  </Button>
                                  <AutoComplete
                                                value={partnerQuery}
                                                id={"partner"}
                                                loading={partnerLoading}
                                                suggestions={partners}
                                                forceSelection
                                                completeMethod={searchPartner}
                                                field={"displayName"}
                                                delay={700}
                                                placeholder={t('typeToSearchPlaceholder')}
                                                className={classNames({'p-invalid': isFormFieldValid(meta)})}
                                                onSelect={(e) => {
                                                  const p = e.value;
                                                  if (!p?.id) return;
                                                  setPartnerQuery(p.displayName || p.name || '');
                                                  setFormData(prev => ({
                                                    ...prev,
                                                    subcontractor: p.id
                                                  }));
                                                  setNewFormData(prev => ({
                                                    ...prev,
                                                    subcontractor: p.id
                                                  }));
                                                  input.onChange(p.id);
                                                }}
                                                onChange={(e) => {
                                                  setPartnerQuery(e.value);
                                                  if (!e.value || String(e.value).trim() === '') {
                                                    setFormData(prev => ({
                                                      ...prev,
                                                      subcontractor: null
                                                    }));
                                                    setNewFormData(prev => ({
                                                      ...prev,
                                                      subcontractor: null
                                                    }));
                                                    input.onChange(null);
                                                  }
                                                }}
                                                onClear={() => {
                                                  setPartnerQuery('');
                                                  setFormData(prev => ({
                                                    ...prev,
                                                    subcontractor: null
                                                  }));
                                                  setNewFormData(prev => ({
                                                    ...prev,
                                                    subcontractor: null
                                                  }));
                                                  input.onChange(null);
                                                }}
                                              />
                                          <Button type="button" className={"p-button"}
                                                  onClick={() => {
                                                    const currentPath = window.location.hash.replace('#', '').split('?')[0];
                                                    let _params = '?';
                                                    Object.entries(window.App.urlVars()).forEach(([key, value]) => {
                                                      _params += key + '=' + value + '&';
                                                    });
                                                    _params += 'backlink=' + encodeURIComponent(currentPath) + '&';
                                                    _params += 'create=partner';
                                                    history.push(currentPath + _params);
                                                  }}>
                                            <i className={"pi pi-plus"}></i>
                                          </Button>
                                        </span>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="deadline" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="deadline"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('deadline')}</label>
                  <div className="p-inputgroup calendar-icon-only">
                    <InputMask id={"deadline"}
                                mask={"9999-99-99"}
                                placeholder={t('datePlaceholder')}
                                value={moment.utc(formData.deadline || null).local().format('YYYY-MM-DD')}
                                onChange={(e) => {
                                  if (e.value.indexOf("_") === -1) {
                                    if (e.value === '') {
                                      e.value = null
                                    }
                                    setFormData({
                                      ...formData,
                                      deadline: new Date(e.value)
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      deadline: new Date(e.value)
                                    })
                                  }
                                }}
                    />
                    <Calendar value={formData.deadline}
                              locale="hu"
                              dateFormat={'yy-mm-dd'}
                              showIcon
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  deadline: e.value
                                })
                                setNewFormData({
                                  ...newFormData,
                                  deadline: e.value
                                })
                              }}/>
                  </div>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-6"}>
              <Field name="status" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label
                    htmlFor="status"
                    className={classNames({'p-error': isFormFieldValid(meta)})}
                  >{props.t('fieldStatus')}</label>

                  <span className="p-d-block">
                    <Dropdown
                      id="status"
                      options={window.App.sortDropdownOptions(status, "value")}
                      optionLabel="value"
                      optionValue="key"
                      placeholder={t('selectStatusActionPlaceholder')}value={formData.status || null}
                      onChange={(e) => {
                        input.onChange(e.value);

                        setFormData({
                          ...formData,
                          status: e.value
                        });

                        setNewFormData({
                          ...newFormData,
                          status: e.value
                        });
                      }}
                      className={classNames({'p-invalid': isFormFieldValid(meta)})}
                    />
                  </span>

                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
                                


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'cooperation' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(CooperationFormComponent);
